import { nanoid } from "nanoid";
import {
  cloneMultilingualBlockContent,
  cloneBlockContentValue
} from "../../utils/cloneBlockContentValue";

type Values = any | { _key: string } | {} | any[];

export const assignArrayKeys = (obj: Values): Values => {
  if (!obj) return obj;
  if (Array.isArray(obj)) return obj.map(assignArrayKeys);
  if (typeof obj == "object") {
    if ("_type" in obj) {
      const _type = obj._type;

      if (typeof _type == "string") {
        if (_type.startsWith("internationalizedArray"))
          return { ...obj, value: cloneBlockContentValue(obj.value) };
        if (
          _type.includes("BlockContent") &&
          !_type.startsWith("multilingualArray")
        )
          return { ...cloneMultilingualBlockContent(obj) };
      }
    }

    const newObj = Object.fromEntries(
      Object.entries({ ...obj }).map(([key, value]) => {
        return [key, assignArrayKeys(value)];
      })
    );

    if (obj._key) {
      newObj._key = nanoid();
    }
    return newObj;
  }

  return obj;
};
